export const getUrlParams = (search) => {
    let hashes = search.slice(search.indexOf('?') + 1).split('&');
    return hashes.reduce((params, hash) => {
        let [key, val] = hash.split('=');
        return Object.assign(params, {[key]: decodeURIComponent(val)})
    }, {})
};

export const isValidSlug = (slug) => {
    // Slug must contain only lowercase letters, numbers, and hyphens
    // Cannot start or end with a hyphen
    const slugPattern = /^[a-z0-9]+(-[a-z0-9]+)*$/;
    return slugPattern.test(slug);
};
